import {FC} from 'react'
import {Form, Button, Spinner} from 'react-bootstrap'
import {LegalDetail} from '../core/_models'
import SummernoteEditor from '../../../../../ui-kit/SummerNote/SummerNote'
import LegalTINAParentDropdown from './LegalParentDropdown'
import CustomTagInput from '../../../../../ui-kit/CustomTagInput/CustomTagInput'
import SegmentedInput from '../../../../../ui-kit/SegmentedInput/SegmentedInput'

type Props = {
  legalDetail: LegalDetail
  handleLegalChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => void
  handleSelectChange: (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => void
  handleCancel: () => void
  handleSubmit: () => void
  internalLoading: boolean
  isFormValid: boolean
  handleParentDropdownChange: (parent_id) => void
}

const LegalTinaForm: FC<Props> = ({
  legalDetail,
  handleLegalChange,
  handleSelectChange,
  handleCancel,
  handleSubmit,
  internalLoading,
  isFormValid,
  handleParentDropdownChange,
}) => {
  return (
    <Form className='form-agreement'>
      <div className='row'>
        <div className='col-12'>
          <h3>General Information</h3>
        </div>
        <div className='col-md-6 mb-3'>
          <Form.Label className='text-primary me-0 ps-0' column>
            <span className='required'>Heading</span>
          </Form.Label>
          <Form.Control
            type='text'
            placeholder='Enter heading'
            name='heading'
            className='required'
            value={legalDetail.heading || ''}
            onChange={handleLegalChange}
          />
        </div>
        <div className='col-md-6 mb-3'>
          <Form.Label className='text-primary me-0 ps-0' column>
            <span className='required'>Unique Code</span>
          </Form.Label>
          <SegmentedInput
            name='unique_code'
            value={legalDetail.unique_code}
            onChange={handleLegalChange}
          />
        </div>
        <div className='col-md-6 mb-3'>
          <Form.Label className='text-primary me-0 ps-0' column>
            Content Parent
          </Form.Label>
          <LegalTINAParentDropdown
            originalParentId={legalDetail.parent_id}
            onSelect={(parent_id) => handleParentDropdownChange(parent_id)}
          />
        </div>
      </div>
      <hr />
      <div className='row'>
        <div className='col-12'>
          <h3>Attributes</h3>
        </div>
        <div className='col-md-6'>
          <Form.Label className='required text-primary me-0 ps-0' column>
            Level
          </Form.Label>
          <Form.Control
            type='number'
            placeholder='Enter level'
            name='level'
            min={0}
            value={legalDetail.level ?? ''}
            onChange={handleLegalChange}
          />
        </div>
        <div className='col-md-6'>
          <Form.Label className='text-primary me-0 ps-0' column>
            Divider
          </Form.Label>
          <div className='d-flex gap-4'>
            <Form.Check
              type='radio'
              label='Yes'
              onChange={handleSelectChange}
              name='divider'
              checked={legalDetail.divider == true}
              value={1}
              id='radio-divider-1'
            />
            <Form.Check
              type='radio'
              label='No'
              onChange={handleSelectChange}
              name='divider'
              checked={legalDetail.divider == false}
              value={0}
              id='radio-divider-2'
            />
          </div>
        </div>
        <div className='col-md-6'>
          <Form.Label className='text-primary me-0 ps-0' column>
            Sub Issue
          </Form.Label>
          <div className='d-flex gap-4'>
            <Form.Check
              type='radio'
              label='Yes'
              value={1}
              onChange={handleSelectChange}
              checked={legalDetail.sub_issue == true}
              name='sub_issue'
              id='radio-issue-1'
            />
            <Form.Check
              type='radio'
              label='No'
              value={0}
              onChange={handleSelectChange}
              checked={legalDetail.sub_issue == false}
              name='sub_issue'
              id='radio-issue-2'
            />
          </div>
        </div>
        <div className='col-md-6'>
          <Form.Label className='text-primary me-0 ps-0' column>
            Upcoming Flag
          </Form.Label>
          <div className='d-flex gap-4'>
            <Form.Check
              type='radio'
              label='Yes'
              onChange={handleSelectChange}
              checked={legalDetail.upcoming_flag == true}
              name='upcoming_flag'
              value={1}
              id='radio-flag-1'
            />
            <Form.Check
              type='radio'
              label='No'
              checked={legalDetail.upcoming_flag == false}
              value={0}
              onChange={handleSelectChange}
              name='upcoming_flag'
              id='radio-flag-2'
            />
          </div>
        </div>
      </div>
      <hr />
      <div className='row'>
        <div className='col-12'>
          <h3>References</h3>
        </div>
        <div className='col-md-6 mb-3'>
          <Form.Label className='text-primary me-0 ps-0' column>
            Recommended Keyword
          </Form.Label>
          <CustomTagInput
            name='recommended_keyword'
            placeholder='Enter recommended keywords'
            value={legalDetail.recommended_keyword}
            onChange={handleLegalChange}
          />
        </div>
      </div>

      <hr />

      <div className='row'>
        <div className='col-md-12 mb-3'>
          <Form.Label className='text-primary me-0 ps-0' column>
            Description
          </Form.Label>
          <SummernoteEditor
            value={legalDetail.description || ''}
            onChange={(html) => {
              const fakeEvent = {
                target: {
                  name: 'description',
                  value: html,
                },
              } as any
              handleLegalChange(fakeEvent)
            }}
          />
        </div>
      </div>
      <div className='row pt-5'>
        <div className='col-lg-12 d-flex justify-content-end gap-3'>
          <Button variant='default' className='btn-cancel' onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            variant='primary'
            onClick={handleSubmit}
            disabled={internalLoading || !isFormValid}
          >
            {internalLoading ? (
              <>
                <Spinner animation='border' size='sm' className='me-2' />
                Submit
              </>
            ) : (
              'Submit'
            )}
          </Button>
        </div>
      </div>
    </Form>
  )
}

export default LegalTinaForm
